export const CURSOR_CONSTANTS = {
    // Scale
    baseScale: 0.5,
    pressedScale: 0.4,
    interactionScale: 0.7,

    // Color
    baseColor: { r: 255, g: 255, b: 255 },
    cardHoverColor: { r: 255, g: 220, b: 80 }, // Gold
    targetHoverValid: { r: 255, g: 0, b: 0 }, // Red
    targetHoverInvalid: { r: 255, g: 50, b: 50 }, // Red

    // Position
    secondMouseGap : 110 + 50, // gapBeetweenSlots + duck width

};

const DEFAULT_BEHAVIOR = {
    idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
    valid: { sprite: "pointerCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.interactionScale },
    invalid: { sprite: "forbidenCursor", anchor: "center", color: CURSOR_CONSTANTS.targetHoverInvalid, scale: CURSOR_CONSTANTS.interactionScale }
};

export const CURSOR_BEHAVIORS = {
    "PAN": {
        idle: { sprite: "targetCursorOff", anchor: "center", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "targetCursorOn", anchor: "center", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: { sprite: "targetCursorOff", anchor: "center", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
    },
    "TIREUR_DELITE": {
        idle: { sprite: "targetCursorOff", anchor: "center", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "targetCursorOn", anchor: "center", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: { sprite: "targetCursorOff", anchor: "center", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
    },
    "EN_JOUE": {
        idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "pointerCursor", anchor: "topleft", color: CURSOR_CONSTANTS.targetHoverValid, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: DEFAULT_BEHAVIOR.invalid
    },
    "RECTIFIER_TIR_DROITE": {
        idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "pointerCursor", anchor: "topleft", color: CURSOR_CONSTANTS.targetHoverValid, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: DEFAULT_BEHAVIOR.invalid
    },
    "RECTIFIER_TIR_GAUCHE": {
        idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "pointerCursor", anchor: "topleft", color: CURSOR_CONSTANTS.targetHoverValid, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: DEFAULT_BEHAVIOR.invalid
    },
    "PALME_AVANT": {
        idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "pointerCursor", anchor: "topleft", color: CURSOR_CONSTANTS.targetHoverValid, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: DEFAULT_BEHAVIOR.invalid
    },
    "PALME_ARRIERE": {
        idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "pointerCursor", anchor: "topleft", color: CURSOR_CONSTANTS.targetHoverValid, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: DEFAULT_BEHAVIOR.invalid
    },
    "EN_AVANT_MARCHE": {
        idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: { sprite: "pointerCursor", anchor: "topleft", color: CURSOR_CONSTANTS.targetHoverValid, scale: CURSOR_CONSTANTS.interactionScale },
        invalid: DEFAULT_BEHAVIOR.invalid
    },
    "DOUBLE_VISEUR": {
        idle: { sprite: "arrowCursor", anchor: "topleft", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: {
            sprite: "pointerCursor",
            anchor: "topleft",
            color: CURSOR_CONSTANTS.targetHoverValid,
            scale: CURSOR_CONSTANTS.interactionScale,
            secondary: true
        },
        invalid: DEFAULT_BEHAVIOR.invalid
    },
    "CANARDAGE": {
        idle: { sprite: "targetCursorOff", anchor: "center", color: CURSOR_CONSTANTS.baseColor, scale: CURSOR_CONSTANTS.baseScale },
        valid: {
            sprite: "targetCursorOn",
            anchor: "center",
            color: CURSOR_CONSTANTS.baseColor,
            scale: CURSOR_CONSTANTS.interactionScale,
            secondary: true
        },
        invalid: { sprite: "forbidenCursor", anchor: "center", color: CURSOR_CONSTANTS.targetHoverInvalid, scale: CURSOR_CONSTANTS.interactionScale, secondary: true }
    },
};

export function getCursorConfig(cardId, stateContext) {
    const cardConfig = CURSOR_BEHAVIORS[cardId] || DEFAULT_BEHAVIOR;
    return cardConfig[stateContext] || DEFAULT_BEHAVIOR[stateContext];
}